import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { useAuth } from '../../hooks/useAuth';
import { useCertificates } from '../../hooks/useCertificates';
import { RECURSO_CERTIFICADOS, temRecurso } from '../../utils/features';
import { mensagemDoAviso } from '../../utils/certificateStatus';

/**
 * Faixa no topo do dashboard: algum certificado a que o usuário tem acesso vence em até 30 dias
 * ou já venceu. Sem a feature liberada não pede nada ao servidor (a rota responderia 404) e,
 * se a lista falhar ou estiver vazia, a faixa simplesmente não aparece.
 */
export function CertificateExpiryBanner() {
  const { membership } = useAuth();
  const liberado = temRecurso(membership, RECURSO_CERTIFICADOS);
  const { certificates, fetchCertificates } = useCertificates();

  useEffect(() => {
    if (liberado) fetchCertificates();
  }, [liberado, fetchCertificates]);

  const mensagem = liberado ? mensagemDoAviso(certificates) : null;
  if (!mensagem) return null;

  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--space-3)',
        flexWrap: 'wrap',
        padding: 'var(--space-4)',
        marginBottom: 'var(--space-6)',
        background: 'rgba(245, 158, 11, 0.08)',
        border: '1px solid rgba(245, 158, 11, 0.25)',
        borderRadius: 'var(--radius-md)',
        color: 'var(--color-text-primary)',
        fontSize: 'var(--text-sm)',
      }}
    >
      <AlertTriangle size={18} style={{ color: '#f59e0b', flexShrink: 0 }} />
      <span style={{ flex: 1 }}>{mensagem}</span>
      <Link to="/certificates" style={{ color: 'var(--color-primary-400)', fontWeight: 'var(--font-medium)', textDecoration: 'none' }}>
        Ver certificados
      </Link>
    </div>
  );
}
